import {
  Box,
  Divider,
  Grid2,
  Paper,
  Portal,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import {
  DataGrid,
  DataGridProps,
  GridFilterModel,
  GridToolbarQuickFilter,
  useGridApiRef,
} from "@mui/x-data-grid";
import React, { forwardRef } from "react";
import { useScreenSize } from "../../hooks";
import { CTableMobile } from "./c-table-mobile.component";

import { ptBR } from "@mui/x-data-grid/locales";

export interface CTableProps<T> extends DataGridProps {
  mobileData?: T[] | T;
  actions?: (item: T) => React.ReactNode;
  title?: string;
  addForm?: () => JSX.Element;
}

export const CTable = React.memo(
  forwardRef<HTMLDivElement, CTableProps<any>>((props, ref) => {
    const apiRef = useGridApiRef();
    const { width } = useScreenSize();
    const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
      items: [],
    });
    const theme = useTheme();

    return (
      <>
        {width <= 900 ? (
          <CTableMobile
            columns={props.columns}
            data={props.rows}
            filterModel={filterModel}
          />
        ) : (
          <Paper
            sx={{
              borderRadius: theme.spacing(2),
              overflow: "hidden",
              marginTop: theme.spacing(2),
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
            }}
          >
            <Toolbar
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6" sx={{ width: "300px" }}>
                {props.title ?? " "}
              </Typography>
              <Grid2
                container
                spacing={3}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid2>
                  <Box id="filter-panel" />
                </Grid2>
                <Grid2>{props.addForm && props.addForm()}</Grid2>
              </Grid2>
            </Toolbar>
            <Divider />
            <Box
              sx={{
                height: "70vh",
              }}
            >
              <DataGrid
                {...props}
                sx={{
                  border: "none",
                }}
                ref={ref}
                apiRef={apiRef}
                localeText={
                  ptBR.components?.MuiDataGrid.defaultProps.localeText
                }
                initialState={{
                  pagination: { paginationModel: { pageSize: 10 } },
                }}
                pageSizeOptions={[5, 10, 25]}
                disableRowSelectionOnClick
                slots={{
                  toolbar: MyCustomToolbar,
                }}
                slotProps={{
                  loadingOverlay: {
                    variant: "skeleton",
                    noRowsVariant: "skeleton",
                  },
                }}
                filterModel={filterModel}
                onFilterModelChange={(newFilterModel) =>
                  setFilterModel(newFilterModel)
                }
              />
            </Box>
          </Paper>
        )}
      </>
    );
  })
);

function MyCustomToolbar() {
  return (
    <Portal container={() => document.getElementById("filter-panel")!}>
      <GridToolbarQuickFilter placeholder="Pesquisar..." />
    </Portal>
  );
}
